



















export default

	props: block: Object

	computed:
		maxWidth: -> @block.maxWidth or 'max-w-small'

		# Root classes
		classes: -> [
			'text-' + @block?.textAlignment?.toLowerCase() if @block?.textAlignment
			@maxWidth
		]

